import { createIdentifier } from '@blocksuite/global/di';
import type { ExtensionType } from '@blocksuite/store';

import { EditorHostKey } from '../../shared/editor-host-context.js';
import type {
  CalendarDataSourceLike,
  CalendarReconcileColumns,
  CalendarReconcileContext,
  CalendarReconcileSnapshot,
} from './calendar-view-types.js';

export type CalendarReconcileSubmitResult = 'completed' | 'pending';

export interface CalendarReconcileSubmitInput {
  columns: CalendarReconcileColumns;
  context: CalendarReconcileContext;
  previousEvent: CalendarReconcileSnapshot | null;
  rowId: string;
  skipMail: boolean;
  viewId: string;
}

export interface CalendarReconcileService {
  onBackendAvailable?(listener: () => void): () => void;
  submit(
    input: CalendarReconcileSubmitInput
  ): Promise<CalendarReconcileSubmitResult>;
}

export const CalendarReconcileProvider =
  createIdentifier<CalendarReconcileService>('calendar-reconcile-service');

export function CalendarReconcileServiceExtension(
  service: CalendarReconcileService
): ExtensionType {
  return {
    setup(di) {
      di.addImpl(CalendarReconcileProvider, () => service);
    },
  };
}

export function resolveCalendarReconcileService(
  dataSource: unknown
): CalendarReconcileService | null {
  const source = dataSource as CalendarDataSourceLike;
  const host = source.serviceGet?.(EditorHostKey) as
    | { std?: { getOptional?: <T>(key: unknown) => T | undefined } }
    | undefined;
  return (
    host?.std?.getOptional?.<CalendarReconcileService>(
      CalendarReconcileProvider
    ) ?? null
  );
}

export function subscribeCalendarBackendAvailable(
  dataSource: unknown,
  listener: () => void
): () => void {
  return (
    resolveCalendarReconcileService(dataSource)?.onBackendAvailable?.(
      listener
    ) ?? (() => {})
  );
}
